export const ROUTING_ACTIVITY_TYPE = "ROUTING_DECISION"
const ASKED_FOR = "Asked for "

export function requestedAttorneyLabel(description: string): string | null {
  const start = description.indexOf(ASKED_FOR)
  if (start < 0) {
    return null
  }
  const from = start + ASKED_FOR.length
  const comma = description.indexOf(",", from)
  const period = description.indexOf(".", from)
  const end = [comma, period].filter((index) => index >= 0).sort((left, right) => left - right)[0]
  if (end === undefined || end <= from) {
    return null
  }
  return description.slice(from, end)
}
